import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { RequestTypeService } from "../../../../shared/services/request-type.service";
import { RequestCategoryService } from "../../../../shared/services/request-categoty.service";
import { forkJoin } from "rxjs";
import { RequestTypeWithCategoriesModel } from "../../../../shared/models/request/request-type-with-categories-model";
import { RequestCategotyWithTypesModel } from "../../../../shared/models/request/request-categoty-with-types-model";
import { UsersService } from "../../../../admin/users/users.service";
import { RequestType } from "../../../../shared/enums";
import { ClientSelectionService } from "../contagent-selection-service";
import { KeyValueObjectsGroup } from "../../../../shared/models/core/KeyValueObjectsGroup";
import { KeyValueObject } from "../../../../shared/models/core/KeyValueObject";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";
import { LookupService } from "../../../../shared/services/lookup.service";
import { CostCentersService } from "../../../../shared/services/cost-centers.service";
import { CostCenterWithAppointment } from "../../../../shared/models/cost-center/cost-center-with-appointment";

@Component({
	selector: 'new-request-general-info',
	templateUrl: './new-request-general-info.component.html',
	styleUrls: ['./new-request-general-info.component.scss',
		'../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
		'../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
	]
})
export class NewRequestGeneralInfoComponent implements OnInit {

    @Input() requestTypeId: number;
    @Input() requestCategoryId: number;
    @Input() requestDescription: string;
    @Input() responsibleUserId: number;
    @Input() costCenterId: number;

    @Output() changeRequestTypeId: EventEmitter<number> = new EventEmitter<number>();
    @Output() changeRequestCategoryId: EventEmitter<number> = new EventEmitter<number>();
    @Output() changeRequestDescription: EventEmitter<string> = new EventEmitter<string>();
    @Output() changeResponsibleUserId: EventEmitter<number> = new EventEmitter<number>();
    @Output() changeCostCenterId: EventEmitter<{ costCenterId: number, confirm: boolean }> = new EventEmitter<{ costCenterId: number, confirm: boolean }>();

    descriptionInputRows: number = 1;
    requestTypeDefaultItem = { id: null, name: "Не выбрано" } as RequestTypeWithCategoriesModel;
    requestCategoryDefaultItem = { id: null, name: "Не выбрано" } as RequestCategotyWithTypesModel;
    responsibleUserDefaultItem = new KeyValueObject(null, "Не выбран");
    costCenterDefaultItem = new KeyValueObject(null, "Не выбран");
    dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };
    private suppressCostCenterChange = false;
    fullCostCenters: CostCenterWithAppointment[] = [];
    costCenters: KeyValueObject[] = [];

    dependentRequestTypes: RequestTypeWithCategoriesModel[] = [];
    dependentRequestCategories: RequestCategotyWithTypesModel[] = [];
    requestTypes: RequestTypeWithCategoriesModel[] = [];
    requestCategories: RequestCategotyWithTypesModel[] = [];
    responsibleUsers: KeyValueObjectsGroup[] = [];
    responsibleUsersDropdownData: KeyValueObject[] = [];
    requestInstallPromotions: KeyValueObject[] = [];

    constructor(
        public requestTypeService: RequestTypeService,
        public requestCategoryService: RequestCategoryService,
        public usersService: UsersService,
        public contragentSelectionService: ClientSelectionService,
        public lookupService: LookupService,
        public costCentersService: CostCentersService
    ) { }

    ngOnInit() {
        const requestTypes$ = this.requestTypeService.getRequestTypesWithCategories();
        const requestCategories$ = this.requestCategoryService.getRequestCategoriesWithTypes();
        const defaultUserRequestType$ = this.usersService.getUserDefaultRequestType();
        const requestInstallPromotions$ = this.lookupService.getData('request-install-promotions', null);
        const costCenters$ = this.costCentersService.getAllWithAppointments();

        forkJoin(requestTypes$, requestCategories$, defaultUserRequestType$, requestInstallPromotions$, costCenters$)
            .subscribe(([requestTypes, requestCategories, defaultUserRequestType, requestInstallPromotions, costCenters]) => {
                this.requestTypes = requestTypes;
                this.requestCategories = requestCategories;
                this.dependentRequestTypes = requestTypes;
                this.dependentRequestCategories = requestCategories.filter(x => !x.disabledForCurrentUser);
                this.requestInstallPromotions = requestInstallPromotions;
                this.fullCostCenters = costCenters;
                this.refreshCostCenterOptions();

                if (this.requestTypeId != null && this.requestTypeId !== 0) {
                    this.requestTypeChange(this.requestTypeId);
                    if (this.requestCategoryId != null && this.requestCategoryId !== 0) {
                        this.requestCategoryChange(this.requestCategoryId);
                    }
                } else if (defaultUserRequestType.hasDefaultRequestType) {
                    this.requestTypeChange(defaultUserRequestType.requestTypeId);
                }
            });
    }

    requestTypeChange(requestTypeId: number) {
        this.requestTypeId = requestTypeId;

        if (requestTypeId != null && requestTypeId != 0) {
            this.dependentRequestCategories = this.requestCategories.filter(x => 
                x.requestTypeIds.some(rt => rt == requestTypeId) && !x.disabledForCurrentUser);

            if (requestTypeId === <number>RequestType.personalWarehouseReplenishment) {
                // TODO есть варианты как нормально захардкодить этого контрагента, чтобы устанавливать его по умолчанию для этого типа заявки?
                const personalWarehouseReplenishmentContragentName = 'Барьер';
                this.contragentSelectionService.forceSelectCongtragent(personalWarehouseReplenishmentContragentName);
            }

            this.loadResponsibleUsers(requestTypeId);
        }
        else {
            this.dependentRequestCategories = this.requestCategories.filter(x => !x.disabledForCurrentUser);
            this.responsibleUsersDropdownData = [];
            this.responsibleUserChange(null);
        }

        this.changeRequestTypeId.emit(requestTypeId);

        if (requestTypeId != null && requestTypeId != 0) {
            this.selectSingleDependentRequestCategory();
        }

        this.refreshCostCenterOptions();
    }

    requestCategoryChange(requestCategoryId: number) {
        this.requestCategoryId = requestCategoryId;

        if (requestCategoryId != null && requestCategoryId != 0) {
            this.dependentRequestTypes = this.requestTypes.filter(x => 
                x.requestCategoryIds.some(rc => rc == requestCategoryId));
        }
        else {
            this.dependentRequestTypes = this.requestTypes;
        }

        this.changeRequestCategoryId.emit(requestCategoryId);

        if (requestCategoryId != null && requestCategoryId != 0) {
            this.selectSingleDependentRequestType();
        }

        this.refreshCostCenterOptions();
    }

    private selectSingleDependentRequestCategory() {
        if (this.dependentRequestCategories.length != 1) {
            return;
        }

        const requestCategoryId = this.dependentRequestCategories[0].id;
        if (this.requestCategoryId == requestCategoryId) {
            return;
        }

        this.requestCategoryChange(requestCategoryId);
    }

    private selectSingleDependentRequestType() {
        if (this.dependentRequestTypes.length != 1) {
            return;
        }

        const requestTypeId = this.dependentRequestTypes[0].id;
        if (this.requestTypeId == requestTypeId) {
            return;
        }

        this.requestTypeChange(requestTypeId);
    }

    requestDescriptionChange() {
        if (this.requestDescription != null) {
            this.descriptionInputRows = this.requestDescription.split('\n').length;
        }

        this.changeRequestDescription.emit(this.requestDescription);
    }

    requestInstallPromotionChange(requestInstallPromotionId: number) {
        if (requestInstallPromotionId) {
            let promotion = this.requestInstallPromotions.find(x => x.id == requestInstallPromotionId);
            this.ensureCostCenterInList(promotion.groupId);
            this.applyCostCenterId(promotion.groupId, true);
        }
        else {
            this.applyCostCenterId(null, true);
        }
    }

    costCenterChange(costCenterId: number) {
        if (this.suppressCostCenterChange) {
            return;
        }

        this.changeCostCenterId.emit({ costCenterId: costCenterId, confirm: true });
    }

    private refreshCostCenterOptions() {
        const allCostCenters = this.mapCostCenters(this.fullCostCenters);
        const requestTypeId = this.requestTypeId;
        const requestCategoryId = this.requestCategoryId;

        if (!requestTypeId || !requestCategoryId) {
            this.costCenters = allCostCenters;
            return;
        }

        const matched = this.fullCostCenters.filter(x =>
            x.appointments.some(a => a.requestTypeId == requestTypeId && a.requestCategoryId == requestCategoryId));

        if (matched.length) {
            this.costCenters = this.mapCostCenters(matched);
            if (!matched.some(x => x.costCenterId == this.costCenterId)) {
                this.applyCostCenterId(matched[0].costCenterId, false);
            }
        } else {
            this.costCenters = allCostCenters;
        }
    }

    private mapCostCenters(items: CostCenterWithAppointment[]): KeyValueObject[] {
        return items.map(x => new KeyValueObject(x.costCenterId, `${x.code} ${x.name}`));
    }

    private ensureCostCenterInList(costCenterId: number) {
        if (costCenterId == null || this.costCenters.some(x => x.id == costCenterId)) {
            return;
        }

        const costCenter = this.fullCostCenters.find(x => x.costCenterId == costCenterId);
        if (costCenter) {
            this.costCenters = this.costCenters.concat(this.mapCostCenters([costCenter]));
        }
    }

    private applyCostCenterId(costCenterId: number, confirm: boolean) {
        this.suppressCostCenterChange = true;
        this.costCenterId = costCenterId;
        this.changeCostCenterId.emit({ costCenterId: costCenterId, confirm: confirm });
        setTimeout(() => this.suppressCostCenterChange = false, 0);
    }

    loadResponsibleUsers(requestTypeId: number) {
        if (requestTypeId != null) {
            if (this.responsibleUsers.some(x => x.groupId == requestTypeId)) {
                this.responsibleUsersDropdownData = this.responsibleUsers.find(x => x.groupId == requestTypeId).objects;
            }
            else {
                this.usersService.getRequestTypeResponsibleUsers(requestTypeId).subscribe(resp => {
                    this.responsibleUsers.push(new KeyValueObjectsGroup(requestTypeId, resp));
                    this.responsibleUsersDropdownData = resp;

                    if (resp.length == 1) {
                        this.responsibleUserChange(resp[0].id);
                    }
                    else if (!resp.some(x => x.id == this.responsibleUserId)) {
                        this.responsibleUserChange(null);
                    }
                });
            }
        }
        else {
            this.responsibleUsersDropdownData = [];
            this.responsibleUserChange(null);
        }
    }

    responsibleUserChange(responsibleUserId: number) {
        this.changeResponsibleUserId.emit(responsibleUserId);
    }

    get isLaboratory(): boolean {
        return this.requestTypeId == <number>RequestType.laboratory;
    }

    get isInstallPromition(): boolean {
        return this.requestTypeId == <number>RequestType.saleInstallation;
    }
}